<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div
  class="formelement_container scheduling_group"
  fxLayout="column"
  [formGroup]="taskSchedulingForm"
>
  <p class="section-title" i18n="@@taskPlanning">Task planning</p>
  <br />
  <mat-checkbox
    id="task_manager_scheduling_toggle"
    formControlName="enableScheduling"
    color="primary"
    i18n="@@scheduleForLater"
    (change)="onSchedulingToggleChange()"
    >Schedule for later</mat-checkbox
  >
  <div class="datetime_picker" fxLayout="row">
    <mat-form-field class="date_picker" appearance="outline">
      <mat-label class="capitalize" i18n="@@startDate">start date</mat-label>
      <input
        id="task_manager_schedule_datepicker_input"
        matInput
        readonly
        [min]="minScheduleDate"
        formControlName="scheduleDate"
        [matDatepicker]="scheduleDate"
        type="text"
      />
      <mat-datepicker-toggle
        id="task_manager_schedule_datepicker_toggle"
        matSuffix
        [for]="scheduleDate"
      ></mat-datepicker-toggle>
      <mat-datepicker
        id="task_manager_schedule_datepicker"
        #scheduleDate
        (closed)="checkScheduleDateTime()"
      ></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="time_picker" appearance="outline">
      <mat-label class="capitalize" i18n="@@time">time</mat-label>
      <input
        id="task_manager_schedule_timepicker_input"
        matInput
        readonly
        formControlName="scheduleTime"
        [ngxTimepicker]="scheduleTime"
        [format]="24"
        type="text"
      />
      <ngx-material-timepicker
        id="task_manager_schedule_timepicker"
        #scheduleTime
        [format]="24"
        (closed)="checkScheduleDateTime()"
      ></ngx-material-timepicker>
      <button
        [disabled]="!formEnableScheduling.value || locked"
        class="clock-icon-button"
        matSuffix
        mat-icon-button
        (click)="scheduleTime.open()"
        type="button"
      >
        <fa-icon class="clock-icon" [icon]="faClock"></fa-icon>
      </button>
    </mat-form-field>
  </div>
  <span
    id="task_manager_schedule_in_past_hint"
    class="multi_formfield_hint warn_hint"
    *ngIf="formEnableScheduling.value && taskScheduledInPast"
    i18n="@@taskScheduledInPastHint"
    >The task will be available immediately, as the selected time is in the past</span
  >
  <div fxLayout="column">
    <mat-checkbox
      id="repeat_task_toggle"
      formControlName="repeatTaskToggle"
      color="primary"
      i18n="@@repeatTask"
      (change)="onRepeatTaskToggleChange()"
      >Repeat task</mat-checkbox
    >

    <div class="task_repetition" fxLayout="column">
      <div fxLayout="row">
        <!-- New repetition cycle control -->
        <mat-form-field appearance="outline" class="repetition-cycle">
          <mat-label class="capitalize" i18n="@@repetitionCycle">repeat every</mat-label>
          <mat-select formControlName="every">
            <mat-option
              *ngFor="
                let cycle of [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
                  24
                ]
              "
              [value]="cycle"
            >
              {{ cycle }}
            </mat-option>
          </mat-select>
          <fa-icon matSuffix [icon]="faMagnifyingGlass" class="select-icon"></fa-icon>
        </mat-form-field>

        <mat-form-field class="repetition" appearance="outline">
          <mat-label class="capitalize" i18n="label for Choose repetition@@repetition"
            >frequency</mat-label
          >
          <mat-select formControlName="recurring">
            <mat-option *ngFor="let frequency of this.recurringFrequency" [value]="frequency.key">
              {{ frequency.value }}
            </mat-option>
          </mat-select>
          <fa-icon matSuffix [icon]="faMagnifyingGlass" class="select-icon"></fa-icon>
        </mat-form-field>
      </div>
      <!-- Monthly pattern selection - only shown for monthly frequency -->
      <div *ngIf="formRecurring.value == 'MONTHLY'" class="monthly-pattern-container">
        <p
          i18n="Select days for execution@@selectDaysForExecution"
          class="capitalize weekdays-paragraph"
        >
          repeat on
        </p>
        <!-- Standard radio options (shown for positions 1-3) -->
        <mat-radio-group
          formControlName="monthlyPatternType"
          class="monthly-pattern-radio-group"
          *ngIf="!isFourthWeekday()"
        >
          <mat-radio-button value="position" color="primary" i18n="@@monthlyPatternRadio">
            Every {{ getPositionText() }} of the month
          </mat-radio-button>
          <mat-radio-button value="date" color="primary" i18n="@@monthlyPatternRadio">
            Every {{ getDateText() }} of the month
          </mat-radio-button>
        </mat-radio-group>

        <!-- Extended radio options (shown when date is 4th occurrence) -->
        <mat-radio-group
          formControlName="monthlyPatternType"
          class="monthly-pattern-radio-group"
          *ngIf="isFourthWeekday()"
        >
          <mat-radio-button value="fourth" color="primary" i18n="@@monthlyPatternRadio">
            Every {{ getFourthPositionText() }} of the month
          </mat-radio-button>
          <mat-radio-button value="last" color="primary" i18n="@@monthlyPatternRadio">
            Every {{ getLastPositionText() }} of the month
          </mat-radio-button>
          <mat-radio-button value="date" color="primary" i18n="@@monthlyPatternRadio">
            Every {{ getDateText() }} of the month
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Weekday selection - shown for daily/weekly patterns -->
      <div
        *ngIf="
          formRecurring.value != 'MONTHLY' &&
          formRecurring.value != 'YEARLY' &&
          !(formRecurring.value == 'DAILY' && (formEvery.value ?? 0) > 1)
        "
        formGroupName="weekdaysControls"
        fxLayout="column"
        class="weekdays-checkboxes-container"
      >
        <p
          i18n="Select days for execution@@selectDaysForExecution"
          class="capitalize weekdays-paragraph"
        >
          repeat on
        </p>
        <div
          fxLayout="row"
          [ngClass]="{
            'read-only-checkbox': formRepeatTaskToggle.value
          }"
        >
          <mat-checkbox
            *ngFor="let item of weekdays"
            [formControlName]="item.key"
            color="primary"
            (change)="onCheckboxesChange(item.key, $event.checked)"
          >
            {{ item.value }}</mat-checkbox
          >
        </div>
      </div>
    </div>

    <!-- New schedule summary text -->
    <div *ngIf="formRepeatTaskToggle.value" class="schedule-summary">
      <p class="summary-text">
        <span i18n="@@taskWillRepeatEvery">The task will repeat every</span>
        <!-- Handle different frequency types with proper ICU expressions -->
        <ng-container [ngSwitch]="formRecurring.value">
          <ng-container *ngSwitchCase="'DAILY'" i18n="@@summaryDays">
            {formEvery.value, plural, =1 {day} other {{{formEvery.value}} days}}
          </ng-container>
          <ng-container *ngSwitchCase="'WEEKDAILY'" i18n="@@summaryWeekdays">
            {formEvery.value, plural, =1 {weekday} other {{{formEvery.value}} weekdays}}
          </ng-container>
          <ng-container *ngSwitchCase="'WEEKLY'" i18n="@@summaryWeeks">
            {formEvery.value, plural, =1 {week} other {{{formEvery.value}} weeks}}
          </ng-container>
          <ng-container *ngSwitchCase="'MONTHLY'" i18n="@@summaryMonths">
            {formEvery.value, plural, =1 {month} other {{{formEvery.value}} months}}
          </ng-container>
          <ng-container *ngSwitchCase="'YEARLY'" i18n="@@summaryYears">
            {formEvery.value, plural, =1 {year} other {{{formEvery.value}} years}}
          </ng-container>
        </ng-container>
        <ng-container *ngIf="getSummaryText()">{{ getSummaryText() }}</ng-container>
        <span i18n="@@startingOn"
          >, starting on
          {{ formScheduleDate.value | date : 'shortDate' : undefined : locale }}
          at {{ formScheduleTime.value }}</span
        >
      </p>
    </div>
  </div>
</div>
